/*** IMPORTS FROM imports-loader ***/
(function() {

define([
      'pip-events',
      'window',
      'pip-model'

  ],
  function(
      pipEvents,
      window,
      pip
  ){
    function initEventListeners(){
      pipEvents.quantity.quantityErrorAnalytics.on(function(evtType, data) {
        var thdAnalyticsEventObject;

        thdAnalyticsEventObject = {
          category: {
            primaryCategory: "error"
          },
          eventInfo: {
            eventName: "post page error",
            error: [
                {
                type: "pip",
                displayType: 'inline',
                pageSection: 'pip',
                message: 'The requested quantity is not available. Please reduce your quantity.',
                code: ''
              }
            ]
          }
        };

        pushAnalyticsEvent(thdAnalyticsEventObject);
      })
    }


    function pushAnalyticsEvent(thdAnalyticsEvent) {

      if (pip.debugMode) {
        console.log('DDO Quantity Event:', thdAnalyticsEvent);
      }

      if (window.digitalData && window.digitalData.event) {
        window.digitalData.event.push(thdAnalyticsEvent);
      }
    }

    return {
      init: function(){
        initEventListeners();
      }
    }
  });

}.call(window));